import {Injectable} from '@angular/core';
import {Mutation} from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root',
})
export class DeleteGpioDevicesMutation extends Mutation {
  document = gql`
      mutation deleteGPIODevice($id: ID!) {
          deleteGPIODevice(where: {id: $id}) {
              id
          }
      }
  `;
}
